import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Badge, IconButton, Popover, List, ListItem, ListItemText, Typography } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useAuth } from '../utilities/Auth';

const NotificationBell = () => {
  const { 
    notifications, 
    unreadCount, 
    markAsRead 
  } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const handleNotificationClick = (notification) => {
    markAsRead(notification.id);
    
    // Navigate based on notification type
    // if (notification.jobId) {
    //   if (notification.type === 'chat_message') {
    //     navigate(`/job/${notification.jobId}/chat`);
    //   } else {
    //     navigate(`/job/${notification.jobId}`);
    //   }
    // } else if (notification.type.includes('wallet')) {
    //   navigate('/wallet');
    // }
    
    handleClose();
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  const open = Boolean(anchorEl);
  const id = open ? 'notification-popover' : undefined;

  return (
    <>
      <IconButton 
        color="#ff6250" 
        onClick={handleClick}
        sx={{
          padding: '8px',
          '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.08)' }
        }}
      >
        <Badge 
          badgeContent={unreadCount} 
          color="error"
          sx={{
            '& .MuiBadge-badge': {
              right: 5,
              top: 5,
              border: '2px solid #1E1E1E',
              padding: '0 4px',
              fontSize: '0.7rem'
            }
          }}
        >
          <NotificationsIcon sx={{ color: '#3d3d3d', fontSize: '1.5rem' }} />
        </Badge>
      </IconButton>
      
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{
          '& .MuiPaper-root': {
            backgroundColor: '#ffff',
            color: '#111',
            borderRadius: '8px',
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.25)',
            width: '350px',
            maxHeight: '400px',
            overflow: 'auto'
          }
        }}
      >
        <div style={{ padding: '16px' }}>
          <Typography variant="h6" style={{ padding: '0 0 16px 0', fontSize: '1.1rem', fontWeight: '600' }}>
            Notifications
          </Typography>
          {notifications.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '20px 0', color: '#111' }}>
              <Typography variant="body1">You're all caught up!</Typography>
              <Typography variant="body2" style={{ marginTop: '8px' }}>
                Might as well take a break and check back later.
              </Typography>
            </div>
          ) : (
            <List dense sx={{ padding: 0 }}>
              {notifications.slice(0, 10).map((notification) => (
                <ListItem 
                  key={notification.id}
                  button
                  onClick={() => handleNotificationClick(notification)}
                  sx={{
                    padding: '5px 16px',
                    '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.05)' },
                    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                    backgroundColor: !notification.read ? 'rgba(0, 119, 255, 0.1)' : 'transparent'
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography 
                        variant="body1" 
                        sx={{ 
                          fontWeight: !notification.read ? '600' : '400',
                          color: !notification.read ? '#111' : '#111'
                        }}
                      >
                        {notification.title}
                      </Typography>
                    }
                    secondary={
                      <>
                        <Typography
                          variant="body2"
                          sx={{ color: '#111', fontSize: '0.85rem' }}
                        >
                          {notification.body}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{ 
                            display: 'block',
                            color: '#111',
                            fontSize: '0.75rem',
                            marginTop: '4px'
                          }}
                        >
                          {formatTime(notification.timestamp)}
                        </Typography>
                      </>
                    }
                  />
                </ListItem>
              ))}
            </List>
          )}
        </div>
      </Popover>
    </>
  );
};

export default NotificationBell;